import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { CUSTOM_APP_DATA } from '../../../assets/configs/app-data';
import { environment } from '../../../../src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { HomePageCount } from '../models/alertPreference';
import { map } from 'rxjs/operators';

@Injectable()
export class LayoutService {
  getAlertTiles: any;
  allUserPermission: any;
  setLoader: boolean;
  busyLoader: BehaviorSubject<any> = new BehaviorSubject([]);
  isExportMRTSubject = new Subject<boolean>();
  data$ = this.isExportMRTSubject.asObservable();

  constructor(private http: HttpClient) {
  }

  getFirmFlowPermision(): Observable<any> {
    const url = environment.base_api_uri + 'v1/administration/user/currentUser';
    return this.http.get<any>(url)
      .pipe(
        map((response) => {
          this.allUserPermission = response;
          return response;
        })
      );
  }
  sendData(data: boolean) {
    this.isExportMRTSubject.next(data);
  }



  getUserAccount(): Observable<any> {
    const url = environment.base_api_uri + 'v1/user/UserAccount';
    return this.http.get<any>(url)
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  public getTiles = (): Observable<any[]> => {
    const url = environment.base_dashboard_api_uri +
      '/dashboard/homepagecount';
    return this.http.get<HomePageCount>(url)
      .pipe(
        map((response) => {
          const alertCount = response.alertCount;
          const workCount = response.workCount;
          const newAlertCount = response.newAlertsCount;
          const newWorkCount = response.newWorkCount;
          const documentCount = response.documentsCount;
          const LinkCount = response.linkCount;
          this.getAlertTiles = CUSTOM_APP_DATA.tiles;
          this.getAlertTiles.forEach(element => {
            if (element.linksText === 'NOTIFICATION RULES') {
              element.count = alertCount;
              element.secondLineText = 'New Alert: ' + newAlertCount;
            }
            if (element.firstLineText === 'My Links') {
              element.count = LinkCount;
            }
            if (element.linksText === 'MY WORK') {
              element.count = workCount;
              element.secondLineText = 'New Task:' + newWorkCount;
              if (this.allUserPermission) {
                element.isVisible = this.allUserPermission.hasFirmFlowAccess;
              }

            }
            if (element.linksText === 'SEARCH') {
              element.count = documentCount;
            }
          });
          return this.getAlertTiles;
        })
      );
  }

  public getUserPreference() {
    const url = environment.base_documents_api_uri + 'v1/user/preferences';
    return this.http.get(url);
  }
  setBusyLoader(loader: boolean) {
    this.busyLoader.next(loader);
  }
  
}
